import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/share.svg")